import { http } from "../utils/http";

export const listPublicProfessionalResults = ({ test_id, candidate_id, q, position } = {}) => {
    const params = new URLSearchParams();
    if (test_id != null && test_id !== "") params.set("test_id", String(test_id));
    if (candidate_id != null && candidate_id !== "") params.set("candidate_id", String(candidate_id));
    if (q) params.set("q", q);
    if (position) params.set("position", position);
    const qs = params.toString();
    return http.get(`/public-test-results${qs ? `?${qs}` : ""}`);
};

export const getPublicProfessionalResult = (id) =>
    http.get(`/public-test-results/${encodeURIComponent(id)}`);

/** Public (no JWT) — take page */
export const getPublicProfessionalTest = (testId, { candidate_id, result_id } = {}) => {
    const params = new URLSearchParams();
    if (candidate_id != null && candidate_id !== "") params.set("candidate_id", String(candidate_id));
    if (result_id != null && result_id !== "") params.set("result_id", String(result_id));
    const qs = params.toString();
    return http.get(`/public/tests/${encodeURIComponent(testId)}${qs ? `?${qs}` : ""}`, { auth: false });
};

export const submitPublicProfessionalResult = (payload) =>
    http.post("/public/tests/results", payload, { auth: false });

export const getPublicTestConsentDocument = (testId) =>
    http.get(`/public/tests/${encodeURIComponent(testId)}/consent-document`, { auth: false });
